import { useContacto } from '../data/contacto'
import './Alergenos.css'

const ALERGENOS = [
  { id: 'gluten', nombre: 'Gluten', icono: '🌾', desc: 'Cereales que contienen gluten: trigo, centeno, cebada, avena, espelta' },
  { id: 'crustaceos', nombre: 'Crustáceos', icono: '🦐', desc: 'Cangrejos, gambas, langostas, percebes' },
  { id: 'huevos', nombre: 'Huevos', icono: '🥚', desc: 'Huevos y productos a base de huevo' },
  { id: 'pescado', nombre: 'Pescado', icono: '🐟', desc: 'Pescado y productos a base de pescado' },
  { id: 'cacahuetes', nombre: 'Cacahuetes', icono: '🥜', desc: 'Cacahuetes y productos a base de cacahuetes' },
  { id: 'soja', nombre: 'Soja', icono: '🫘', desc: 'Soja y productos a base de soja' },
  { id: 'lacteos', nombre: 'Lácteos', icono: '🥛', desc: 'Leche y sus derivados, incluida la lactosa' },
  { id: 'frutos_secos', nombre: 'Frutos secos', icono: '🌰', desc: 'Almendras, avellanas, nueces, anacardos, pistachos...' },
  { id: 'apio', nombre: 'Apio', icono: '🥬', desc: 'Apio y productos derivados' },
  { id: 'mostaza', nombre: 'Mostaza', icono: '🌿', desc: 'Mostaza y productos derivados' },
  { id: 'sesamo', nombre: 'Sésamo', icono: '🌱', desc: 'Granos de sésamo y productos a base de sésamo' },
  { id: 'sulfitos', nombre: 'Sulfitos', icono: '🍷', desc: 'Dióxido de azufre y sulfitos en concentraciones >10mg/kg' },
  { id: 'moluscos', nombre: 'Moluscos', icono: '🐚', desc: 'Almejas, mejillones, ostras, calamares, pulpo' },
  { id: 'altramuces', nombre: 'Altramuces', icono: '🌼', desc: 'Altramuces y productos a base de altramuces' },
]

export default function Alergenos() {
  const c = useContacto()
  return (
    <div className="page alergenos-page">
      <div className="page-header">
        <p className="page-label">Información legal</p>
        <h1 className="page-title">Alérgenos</h1>
        <div className="page-divider"></div>
        <p className="alergenos-intro">
          En El Rincón de la Escandella nos tomamos muy en serio la seguridad alimentaria de nuestros clientes.
          A continuación encontrarás información sobre los 14 alérgenos de declaración obligatoria según el
          Reglamento (UE) Nº 1169/2011. Si tienes alguna alergia o intolerancia, consulta con nuestro personal
          antes de realizar tu pedido.
        </p>
      </div>

      <div className="alergenos-grid">
        {ALERGENOS.map(a => (
          <div key={a.id} className="alergeno-card">
            <div className="alergeno-icono">{a.icono}</div>
            <div className="alergeno-info">
              <h3 className="alergeno-nombre">{a.nombre}</h3>
              <p className="alergeno-desc">{a.desc}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="alergenos-aviso">
        <p className="aviso-titulo">⚠ Aviso importante</p>
        <p>Aunque tomamos todas las precauciones necesarias, nuestras cocinas no son libres de alérgenos.
        Existe riesgo de contaminación cruzada. Si tienes una alergia grave, por favor comunícalo a nuestro personal.</p>
        <p style={{ marginTop: '0.5rem' }}>Para más información: <strong>{c.email}</strong></p>
      </div>
    </div>
  )
}
